export default class Extension {
  constructor(
    public id: number,
    public code: string,
    public name: string,
    public nameWithNewline: string | null,
    public description: string,
    public createdAt: Date,
    public updatedAt: Date,
  ) {}
}
